import { useCallback, useMemo } from 'react';
import { ButtonWithIcon } from 'src/components/Buttons';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { IconsFill, MinusIcon, PlusIcon } from 'src/svgs/Viagogo';
import {
  getAllInPriceFromListPriceForListing,
  getListPriceFromAllinPrice,
} from 'src/utils/inventoryUtils';
import { applyNumberFormatting } from 'src/utils/numberFormatter';
import { Listing } from 'src/WebApiController';

import { useMobileListingDrawerContext } from '../MobileListingDrawerContext';
import * as styles from './MobilePriceInput.css';

export const MobilePriceInput = ({ listing }: { listing: Listing }) => {
  const { toggleEditingListing, onSaveListingPrice } =
    useMobileListingDrawerContext();
  const allInPrice = useMemo(() => {
    const inferredAllInPrice = getAllInPriceFromListPriceForListing(listing);

    return applyNumberFormatting({
      inputNumber: inferredAllInPrice,
      currencyCode: listing.currency,
    });
  }, [listing]);

  const onUpdatePrice = useCallback(
    (add: boolean) => {
      const inferredAllInPrice = getAllInPriceFromListPriceForListing(listing);
      if (!inferredAllInPrice) {
        return;
      }
      const updatedAllInPrice = add
        ? inferredAllInPrice + 1
        : inferredAllInPrice - 1;
      const updateListPrice = getListPriceFromAllinPrice(
        updatedAllInPrice,
        listing
      );
      if (!updateListPrice) {
        return;
      }

      onSaveListingPrice(updateListPrice);
    },
    [listing, onSaveListingPrice]
  );

  return (
    <Stack
      direction="row"
      justifyContent="spaceBetween"
      alignItems="center"
      className={styles.inputContainer}
      onClick={() => toggleEditingListing(listing)}
    >
      <ButtonWithIcon
        shape="rect"
        disabled={!allInPrice}
        className={styles.stepperButton}
        icon={
          <MinusIcon size={vars.iconSize.m} fill={IconsFill.textInverted} />
        }
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onUpdatePrice(false);
        }}
      />
      <span style={{ color: vars.color.textPrimary }}>{allInPrice}</span>
      <ButtonWithIcon
        shape="rect"
        disabled={!allInPrice}
        className={styles.stepperButton}
        icon={<PlusIcon size={vars.iconSize.m} fill={IconsFill.textInverted} />}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onUpdatePrice(true);
        }}
      />
    </Stack>
  );
};
